import React from 'react';

const Location = ({organizer}) => {
  return (
    <section className="company-fifth">
      <div className="container">
        <table className="table-borderless w-100" style={{marginBottom: '50px'}}>
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px',fontWeight: '600'}}>Lokasi Penyelenggara</p>
            </td>
            <td className="tb" style={{width: '80%'}}>
              <div className="d-lg-block d-md-block d-sm-none d-none" style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
          </tr>
        </table>
        <div style={{position: 'relative', textAlign: 'right', height: '400px',width: '100%'}}>
          <div style={{overflow: 'hidden',background: 'none !important', height: '400px', width: '100%'}}>
            <iframe id="gmap_canvas" width="100%" height="400" 
            src={`https://maps.google.com/maps?q=${organizer.locationKeyword ? organizer.locationKeyword : 'Kementerian Komunikasi dan Informatika Republik Indonesia, Jalan Medan Merdeka Barat, RT.2/RW.3, Gambir, Central Jakarta City, Jakarta'}%20&amp&t=&amp&z=13&amp&ie=UTF8&amp&iwloc=&amp&output=embed`}
            frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>Google Maps Generator by <a href="https://www.embedgooglemap.net">embedgooglemap.net</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Location